// import { useState, useEffect, useRef, useContext, useCallback } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Client } from "@stomp/stompjs";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";
// import { motion, AnimatePresence } from "framer-motion";

// const WS_URL = "wss://waws.deetyasoft.com/sendMessage";

// // Pages where the notification must never appear
// const PUBLIC_ROUTES = [
//   "/", "/login", "/register", "/reset-password", "/oauth-callback",
//   "/about-us", "/contact", "/pricing", "/features",
//   "/privacy-policy", "/terms-and-conditions",
//   "/solutions/healthcare", "/solutions/education", "/solutions/real-estate",
//   "/solutions/insurance", "/solutions/banking-finance", "/solutions/technology",
// ];

// const WhastappNotification = () => {
//   const { user } = useContext(AuthContext);
//   const token = user?.token || localStorage.getItem("token");
//   const companyId = user?.accountType === "COMPANY" ? user?.id : user?.companyId;
//   const [showFullMessage, setShowFullMessage] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [apiKey, setApiKey] = useState(null);
//   const [toast, setToast] = useState(null); // { number, contactName, message }

//   const stompClientRef = useRef(null);
//   const subRef = useRef(null);
//   const dismissTimerRef = useRef(null);

//   const isAuthenticated = !!token;
//   const isPublicRoute = PUBLIC_ROUTES.includes(location.pathname);

//   // Fetch the WhatsApp apiKey (needed to build the topic name)
//   useEffect(() => {
//     if (!isAuthenticated || !companyId) return;
//     let cancelled = false;

//     (async () => {
//       try {
//         const res = await fetch(`${API_URL}/api/whatsappConfig/${companyId}`, {
//           headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
//         });
//         const result = await res.json();
//         if (!cancelled && res.ok && result.status === "success" && result.data?.apiKey) {
//           setApiKey(result.data.apiKey);
//         }
//       } catch (err) {
//         console.error("WhastappNotification: failed to load config", err);
//       }
//     })();

//     return () => { cancelled = true; };
//   }, [isAuthenticated, companyId, token]);

//   const MEDIA_TYPE_LABELS = {
//     image: "📷 Photo",
//     video: "🎥 Video",
//     audio: "🎵 Audio",
//     document: "📄 Document",
//   };

//   // Tries every common shape a WhatsApp-style payload sends text in.
//   const extractMessageText = (data) => {
//     if (typeof data.message === "string" && data.message.trim()) return data.message;
//     if (typeof data.text === "string" && data.text.trim()) return data.text;

//     // Nested shapes, e.g. { message: { body: "..." } } or { text: { body: "..." } }
//     if (data.message && typeof data.message === "object") {
//       if (data.message.body) return data.message.body;
//       if (data.message.text) return data.message.text;
//     }
//     if (data.text && typeof data.text === "object" && data.text.body) {
//       return data.text.body;
//     }

//     // Type-keyed shape, e.g. { type: "text", text: { body: "..." } }
//     if (data.type && data[data.type]) {
//       const typed = data[data.type];
//       if (typeof typed === "string") return typed;
//       if (typed?.body) return typed.body;
//       if (typed?.caption) return typed.caption;
//     }

//     if (data.body) return data.body;
//     if (data.caption) return data.caption;

//     return MEDIA_TYPE_LABELS[data.type] || "Sent you a new message";
//   };

//   const handleNotification = useCallback((rawBody) => {
//     let data;
//     try {
//       data = JSON.parse(rawBody);
//     } catch (e) {
//       console.error("WhastappNotification: bad payload", e, rawBody);
//       return;
//     }

//     // 🔧 TEMP DEBUG: check this in your browser console to confirm the real field names,
//     // then this line + comment can be removed.
//     console.log("WhastappNotification raw payload:", data);

//     // Only show a popup for messages the customer sent us, not our own outgoing sends
//     if (data.direction && data.direction !== "INCOMING") return;

//     const number = data.from || data.number || data.sender;
//     if (!number) return;

//     const contactName = data.contactName || data.senderName || number;
//     const message = extractMessageText(data);

//     setToast({ number, contactName, message });
//     setShowFullMessage(false);

//     if (dismissTimerRef.current) clearTimeout(dismissTimerRef.current);
//     dismissTimerRef.current = setTimeout(() => setToast(null), 8000);
//   }, []);

//   // Independent STOMP connection dedicated to notifications
//   useEffect(() => {
//     if (!isAuthenticated || !apiKey) return;

//     const client = new Client({
//       brokerURL: WS_URL,
//       reconnectDelay: 5000,
//       heartbeatIncoming: 10000,
//       heartbeatOutgoing: 10000,
//       onConnect: () => {
//         const topic = `/topic/notifications/${apiKey}`;
//         subRef.current = client.subscribe(topic, (frame) => handleNotification(frame.body));
//       },
//     });

//     stompClientRef.current = client;
//     client.activate();

//     return () => {
//       try { subRef.current?.unsubscribe(); } catch (_) {}
//       client.deactivate();
//       stompClientRef.current = null;
//     };
//   }, [isAuthenticated, apiKey, handleNotification]);

//   const handleOpenChat = () => {
//     if (!toast?.number) return;
//     const number = toast.number;
//     setToast(null);
//     navigate("/chat", { state: { openContactNumber: number } });
//   };

//   const handleDismiss = () => {
//     if (dismissTimerRef.current) clearTimeout(dismissTimerRef.current);
//     setToast(null);
//   };

//   if (!isAuthenticated || isPublicRoute) return null;

//   return (
//     <AnimatePresence>
//       {toast && (
//         <motion.div
//           initial={{ opacity: 0, x: 400 }}
//           animate={{ opacity: 1, x: 0 }}
//           exit={{ opacity: 0, x: 400 }}
//           transition={{ duration: 0.35, ease: "easeOut" }}
//           className="fixed top-20 right-4 z-[9999] w-[320px] bg-white dark:bg-[#233138] rounded-xl shadow-2xl border border-gray-200 dark:border-[#323d43] overflow-hidden"
//         >
//           <div className="flex items-start gap-3 p-4">
//             <div className="w-10 h-10 rounded-full bg-[#00a884] flex items-center justify-center text-white font-semibold shrink-0">
//               {String(toast.contactName || "U").slice(0, 2).toUpperCase()}
//             </div>
//             <div className="flex-1 min-w-0">
//               <div className="flex items-center justify-between">
//                 <p className="text-[14px] font-semibold text-gray-900 dark:text-[#e9edef] truncate">
//                   {toast.contactName}
//                 </p>
//                 <button
//                   onClick={handleDismiss}
//                   className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 bg-transparent border-none outline-none ml-2 shrink-0"
//                 >
//                   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                     <path d="M6 18L18 6M6 6l12 12" />
//                   </svg>
//                 </button>
//               </div>

//               <div className="relative">
//                 <p
//                   className="text-[13px] text-gray-500 dark:text-[#8696a0] truncate mt-0.5 cursor-default"
//                   onMouseEnter={() => setShowFullMessage(true)}
//                   onMouseLeave={() => setShowFullMessage(false)}
//                 >
//                   {toast.message}
//                 </p>

//                 {showFullMessage && toast.message && toast.message.length > 35 && (
//                   <div className="absolute right-full top-0 mr-2 max-w-[240px] bg-gray-900 text-white text-[12px] leading-snug rounded-lg px-3 py-2 shadow-xl whitespace-normal break-words z-[10000]">
//                     {toast.message}
//                     <div className="absolute top-3 -right-1 w-2 h-2 bg-gray-900 rotate-45" />
//                   </div>
//                 )}
//               </div>

//               <button
//                 onClick={handleOpenChat}
//                 className="mt-2 text-[13px] font-medium text-white bg-[#00a884] hover:bg-[#008f6f] rounded-lg px-3 py-1.5 border-none outline-none transition-colors"
//               >
//                 Open Chat
//               </button>
//             </div>
//           </div>
//         </motion.div>
//       )}
//     </AnimatePresence>
//   );
// };

// export default WhastappNotification;








import { useState, useEffect, useRef, useContext, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Client } from "@stomp/stompjs";
import { AuthContext } from "../context/AuthContext";
import { API_URL } from "../../Constants";
import { motion, AnimatePresence } from "framer-motion";

/* ------------------------------------------------------------------ *
 *  WhatsApp "chat heads" + docked mini chatboxes (Facebook 2015 style)
 *
 *  - New incoming message  -> round bubble on the right edge (stacked)
 *  - Click a bubble        -> small chatbox docks to the bottom-right
 *  - Chatbox               -> live messages + instant reply, no page change
 *
 *  Drop-in replacement for the old toast: same file, same default export,
 *  still mounted once in App.js as <WhastappNotification />.
 * ------------------------------------------------------------------ */

const WS_URL = "wss://waws.deetyasoft.com/sendMessage";

// Pages where the bubbles must never appear
const PUBLIC_ROUTES = [
  "/", "/login", "/register", "/reset-password", "/oauth-callback",
  "/about-us", "/contact", "/pricing", "/features",
  "/privacy-policy", "/terms-and-conditions",
  "/solutions/healthcare", "/solutions/education", "/solutions/real-estate",
  "/solutions/insurance", "/solutions/banking-finance", "/solutions/technology",
];

const MAX_BUBBLES = 6;          // bubbles kept on screen
const BOX_WIDTH = 328;          // chatbox width (px)
const BOX_GAP = 12;             // gap between side-by-side chatboxes
const BUBBLE_COLUMN_WIDTH = 84; // space reserved on the right for the bubble column
const HISTORY_SIZE = 30;        // messages loaded when a chatbox opens

const MEDIA_TYPE_LABELS = {
  image: "📷 Photo",
  video: "🎥 Video",
  audio: "🎵 Audio",
  document: "📄 Document",
};

/* ----------------------------- helpers ----------------------------- */

const toMs = (v) => {
  const t = new Date(v).getTime();
  return Number.isNaN(t) ? 0 : t;
};

const formatTime = (ts) => {
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
};

const isReaction = (m) => {
  if (!m) return false;
  const text = m.message || m.text;
  return m.type === "reaction" || (m.type === "text" && typeof text === "string" && text.startsWith("Reacted with"));
};

// Tries every common shape a WhatsApp-style payload sends text in.
const extractMessageText = (data) => {
  if (typeof data.message === "string" && data.message.trim()) return data.message;
  if (typeof data.text === "string" && data.text.trim()) return data.text;

  if (data.message && typeof data.message === "object") {
    if (data.message.body) return data.message.body;
    if (data.message.text) return data.message.text;
  }
  if (data.text && typeof data.text === "object" && data.text.body) return data.text.body;

  if (data.type && data[data.type]) {
    const typed = data[data.type];
    if (typeof typed === "string") return typed;
    if (typed?.body) return typed.body;
    if (typed?.caption) return typed.caption;
  }

  if (data.body) return data.body;
  if (data.caption) return data.caption;

  return MEDIA_TYPE_LABELS[data.type] || "Sent you a new message";
};

// Normalises a message coming from the history API or the chatMessages topic
const formatMessage = (msg, idx = 0) => {
  const type = msg.type || "text";
  let text = typeof msg.message === "string" ? msg.message : typeof msg.text === "string" ? msg.text : "";
  if (!text) text = MEDIA_TYPE_LABELS[type] || (type !== "text" ? `Sent a ${type}` : "");
  const timestamp = msg.timestamp || msg.time || new Date().toISOString();
  return {
    id: msg.wamid || msg.messageId || `local-${toMs(timestamp)}-${idx}-${Math.random().toString(36).slice(2, 7)}`,
    text,
    type,
    sender: msg.direction === "INCOMING" ? "them" : "me",
    timestamp,
    status: msg.status || (msg.direction === "INCOMING" ? "delivered" : "sent"),
  };
};

const isTemp = (m) => String(m.id).startsWith("temp-");

// Same message? (same id, or an optimistic temp message matched with its real echo)
const isSameMessage = (a, b) => {
  if (a.id === b.id) return true;
  if (isTemp(a) !== isTemp(b) && a.sender === b.sender && a.text === b.text) {
    return Math.abs(toMs(a.timestamp) - toMs(b.timestamp)) < 30000;
  }
  return false;
};

const mergeMessages = (base, extra) => {
  const out = [...base];
  extra.forEach((m) => {
    if (!out.some((x) => isSameMessage(x, m))) out.push(m);
  });
  return out.sort((a, b) => toMs(a.timestamp) - toMs(b.timestamp));
};

const initialsOf = (name) => {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length || /^\+?\d+$/.test(parts[0])) return null; // numeric -> show icon
  return parts.slice(0, 2).map((p) => p[0]).join("").toUpperCase();
};

const readStore = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key) || "{}") || {};
  } catch (_) {
    return {};
  }
};

// Keeps the Sidebar badge + Chat page in sync (same keys/events they already use)
const markGlobalRead = (companyId, number, ts) => {
  if (!companyId || !number) return;
  try {
    const readKey = `wa_lastread_${companyId}`;
    const readMap = readStore(readKey);
    const next = toMs(ts) || Date.now();
    if (next > toMs(readMap[number])) {
      readMap[number] = new Date(next).toISOString();
      localStorage.setItem(readKey, JSON.stringify(readMap));
    }
    const unreadKey = `wa_unread_${companyId}`;
    const unread = readStore(unreadKey);
    if (unread[number]) {
      delete unread[number];
      localStorage.setItem(unreadKey, JSON.stringify(unread));
      window.dispatchEvent(new Event("wa_unread_changed"));
    }
  } catch (_) { /* ignore */ }
};

/**
 * Claim-on-first-reply model: a new chat is shown to every executive; whoever
 * replies first owns it and everyone else is locked out (enforced by the backend).
 *
 *  - COMPANY accounts see every chat.
 *  - Unassigned chat           -> everyone gets a bubble.
 *  - Chat owned by someone else -> no bubble, and any open box is locked.
 *
 * The owner is read from the payload (assignedTo / assignedToId / executiveId /
 * claimedBy). If your backend uses another field name, add it to `assigneeOf`.
 */
const assigneeOf = (data) => {
  const v = data?.assignedTo ?? data?.assignedToId ?? data?.executiveId ?? data?.claimedBy ?? null;
  if (v && typeof v === "object") return v.id ?? null;
  return v;
};

const shouldNotify = (data, user) => {
  if (user?.accountType === "COMPANY") return true;
  const owner = assigneeOf(data);
  return owner == null || String(owner) === String(user?.id);
};

// HTTP statuses the backend uses when a chat belongs to another executive
const isClaimedStatus = (status) => status === 403 || status === 409;

const useViewportWidth = () => {
  const [w, setW] = useState(typeof window !== "undefined" ? window.innerWidth : 1280);
  useEffect(() => {
    const onResize = () => setW(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return w;
};

/* ----------------------------- icons ----------------------------- */

const Icon = ({ d, size = 16, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...rest}>
    <path d={d} />
  </svg>
);
const ICON_CLOSE = "M6 18L18 6M6 6l12 12";
const ICON_MIN = "M5 12h14";
const ICON_EXPAND = "M14 3h7v7M10 14L21 3M21 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5";
const ICON_SEND = "M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z";
const ICON_USER = "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z";

/* ----------------------------- bubble ----------------------------- */

const ChatHead = ({ chat, onOpen, onDismiss }) => {
  const initials = initialsOf(chat.name);
  return (
    <motion.div
      layout
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      exit={{ scale: 0, opacity: 0 }}
      transition={{ type: "spring", stiffness: 400, damping: 26 }}
      className="relative group"
    >
      {/* ping ring each time a new message lands */}
      {chat.unread > 0 && (
        <motion.span
          key={chat.lastTs}
          initial={{ scale: 1, opacity: 0.55 }}
          animate={{ scale: 1.7, opacity: 0 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          className="absolute inset-0 rounded-full bg-[#00a884] pointer-events-none"
        />
      )}

      <button
        onClick={onOpen}
        aria-label={`Open chat with ${chat.name}`}
        className={`relative w-[52px] h-[52px] rounded-full bg-[#00a884] hover:bg-[#008f6f] text-white font-semibold text-[16px] shadow-lg flex items-center justify-center border-2 outline-none transition-colors ${
          chat.open ? "border-white ring-2 ring-[#00a884]" : "border-white dark:border-gray-700"
        }`}
      >
        {initials || <Icon d={ICON_USER} size={22} />}
      </button>

      {chat.unread > 0 && (
        <span className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1 rounded-full bg-red-500 text-white text-[11px] font-bold flex items-center justify-center shadow pointer-events-none">
          {chat.unread > 99 ? "99+" : chat.unread}
        </span>
      )}

      {/* hover preview (hidden while this chat's box is open) */}
      {!chat.open && (
        <div className="pointer-events-none absolute right-full top-1/2 -translate-y-1/2 mr-3 hidden group-hover:block w-max max-w-[230px] bg-gray-900 text-white rounded-lg px-3 py-2 shadow-xl">
          <p className="text-[12px] font-semibold truncate">{chat.name}</p>
          <p
            className="text-[12px] opacity-80 break-words"
            style={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}
          >
            {chat.preview}
          </p>
          <div className="absolute top-1/2 -translate-y-1/2 -right-1 w-2 h-2 bg-gray-900 rotate-45" />
        </div>
      )}

      {/* dismiss */}
      <button
        onClick={(e) => { e.stopPropagation(); onDismiss(); }}
        aria-label="Dismiss"
        className="absolute -top-1 -left-1 hidden group-hover:flex w-5 h-5 rounded-full bg-gray-700 hover:bg-gray-900 text-white items-center justify-center border-none outline-none shadow"
      >
        <Icon d={ICON_CLOSE} size={11} />
      </button>
    </motion.div>
  );
};

/* ----------------------------- chatbox ----------------------------- */

const ChatBox = ({ chat, right, isMobile, onClose, onToggleMinimize, onSend, onRetry, onOpenFull }) => {
  const [draft, setDraft] = useState("");
  const listRef = useRef(null);
  const inputRef = useRef(null);
  const stickToBottomRef = useRef(true);
  const initials = initialsOf(chat.name);

  useEffect(() => {
    if (!chat.minimized) inputRef.current?.focus();
  }, [chat.minimized]);

  useEffect(() => {
    const el = listRef.current;
    if (el && stickToBottomRef.current) el.scrollTop = el.scrollHeight;
  }, [chat.messages.length, chat.minimized, chat.status]);

  const handleScroll = () => {
    const el = listRef.current;
    if (!el) return;
    stickToBottomRef.current = el.scrollHeight - el.scrollTop - el.clientHeight < 60;
  };

  const submit = () => {
    const text = draft.trim();
    if (!text) return;
    stickToBottomRef.current = true;
    onSend(text);
    setDraft("");
    if (inputRef.current) inputRef.current.style.height = "auto";
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey && !e.nativeEvent.isComposing) {
      e.preventDefault();
      submit();
    }
  };

  const handleInput = (e) => {
    setDraft(e.target.value);
    const el = e.target;
    el.style.height = "auto";
    el.style.height = `${Math.min(el.scrollHeight, 84)}px`;
  };

  const stop = (fn) => (e) => { e.stopPropagation(); fn(); };
  const showHeaderBadge = chat.minimized && chat.unread > 0;

  return (
    <div
      className="fixed bottom-0 z-[9991]"
      style={{ right, width: isMobile ? "100%" : BOX_WIDTH, transition: "right .25s ease" }}
    >
      <motion.div
        initial={{ y: 40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 40, opacity: 0 }}
        transition={{ duration: 0.2 }}
        className={`flex flex-col bg-white dark:bg-[#111b21] shadow-2xl border border-gray-300 dark:border-[#323d43] overflow-hidden ${
          isMobile ? "rounded-t-2xl" : "rounded-t-lg"
        }`}
        style={{
          height: chat.minimized ? 44 : isMobile ? "72vh" : "min(420px, calc(100vh - 80px))",
          transition: "height .2s ease",
        }}
      >
        {/* header (click = minimise / restore, like Facebook) */}
        <div
          onClick={onToggleMinimize}
          className={`h-[44px] shrink-0 flex items-center gap-2 px-3 text-white cursor-pointer select-none ${
            showHeaderBadge ? "bg-[#008f6f]" : "bg-[#00a884]"
          }`}
        >
          <div className="w-7 h-7 rounded-full bg-white/25 flex items-center justify-center text-[12px] font-semibold shrink-0">
            {initials || <Icon d={ICON_USER} size={14} />}
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-[14px] font-semibold truncate leading-tight">{chat.name}</p>
            {chat.name !== chat.number && (
              <p className="text-[11px] opacity-80 truncate leading-tight">{chat.number}</p>
            )}
          </div>
          {showHeaderBadge && (
            <span className="min-w-[20px] h-5 px-1 rounded-full bg-red-500 text-white text-[11px] font-bold flex items-center justify-center">
              {chat.unread > 99 ? "99+" : chat.unread}
            </span>
          )}
          <button onClick={stop(onOpenFull)} title="Open in full chat" aria-label="Open in full chat"
            className="p-1 rounded text-white/90 hover:text-white hover:bg-white/20 bg-transparent border-none outline-none">
            <Icon d={ICON_EXPAND} size={15} />
          </button>
          <button onClick={stop(onToggleMinimize)} title="Minimise" aria-label="Minimise"
            className="p-1 rounded text-white/90 hover:text-white hover:bg-white/20 bg-transparent border-none outline-none">
            <Icon d={ICON_MIN} size={15} />
          </button>
          <button onClick={stop(onClose)} title="Close" aria-label="Close"
            className="p-1 rounded text-white/90 hover:text-white hover:bg-white/20 bg-transparent border-none outline-none">
            <Icon d={ICON_CLOSE} size={15} />
          </button>
        </div>

        {/* messages */}
        <div
          ref={listRef}
          onScroll={handleScroll}
          className="flex-1 min-h-0 overflow-y-auto px-3 py-3 space-y-1.5 bg-[#efeae2] dark:bg-[#0b141a]"
        >
          {chat.status === "loading" && chat.messages.length === 0 && (
            <p className="text-center text-[12px] text-gray-500 dark:text-[#8696a0] py-6">Loading messages…</p>
          )}
          {chat.status === "error" && chat.messages.length === 0 && (
            <div className="text-center py-6">
              <p className="text-[12px] text-gray-500 dark:text-[#8696a0]">Couldn’t load this conversation.</p>
              <button onClick={() => onRetry()} className="mt-2 text-[12px] font-medium text-[#00a884] bg-transparent border-none outline-none underline">
                Try again
              </button>
            </div>
          )}

          {chat.messages.map((m) => {
            const mine = m.sender === "me";
            const failed = m.status === "failed";
            return (
              <div key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`}>
                <div
                  className={`max-w-[82%] rounded-lg px-2.5 py-1.5 text-[13px] leading-snug shadow-sm break-words whitespace-pre-wrap ${
                    mine
                      ? "bg-[#d9fdd3] text-gray-900 dark:bg-[#005c4b] dark:text-[#e9edef]"
                      : "bg-white text-gray-900 dark:bg-[#202c33] dark:text-[#e9edef]"
                  }`}
                >
                  {m.text}
                  {m.type !== "text" && (
                    <span className="block text-[11px] italic opacity-60 mt-0.5">Open full chat to view</span>
                  )}
                  <div className="mt-0.5 text-right text-[10px] opacity-60">
                    {failed ? (
                      <button onClick={() => onRetry(m)} className="text-red-500 font-medium bg-transparent border-none outline-none p-0">
                        Failed · tap to retry
                      </button>
                    ) : m.status === "sending" ? (
                      "Sending…"
                    ) : (
                      formatTime(m.timestamp)
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* composer (or lock banner when another executive owns the chat) */}
        {chat.locked ? (
          <div className="shrink-0 px-3 py-3 text-center text-[12px] leading-snug border-t border-amber-200 dark:border-[#323d43] bg-amber-50 dark:bg-[#2a3942] text-amber-800 dark:text-amber-300">
            🔒 {chat.lockMessage}
          </div>
        ) : (
        <div className="shrink-0 flex items-end gap-2 p-2 border-t border-gray-200 dark:border-[#323d43] bg-gray-50 dark:bg-[#202c33]">
          <textarea
            ref={inputRef}
            rows={1}
            value={draft}
            onChange={handleInput}
            onKeyDown={handleKeyDown}
            placeholder="Type a reply…"
            className="flex-1 resize-none rounded-2xl px-3 py-2 text-[13px] leading-snug border border-gray-300 dark:border-[#323d43] outline-none bg-white dark:bg-[#2a3942] text-gray-900 dark:text-[#e9edef] placeholder-gray-400 dark:placeholder-[#8696a0] max-h-[84px]"
          />
          <button
            onClick={submit}
            disabled={!draft.trim()}
            aria-label="Send"
            className="w-[34px] h-[34px] shrink-0 rounded-full bg-[#00a884] hover:bg-[#008f6f] disabled:opacity-40 disabled:cursor-not-allowed text-white flex items-center justify-center border-none outline-none transition-colors"
          >
            <Icon d={ICON_SEND} size={16} />
          </button>
        </div>
        )}
      </motion.div>
    </div>
  );
};

/* ----------------------------- main ----------------------------- */

const WhastappNotification = () => {
  const { user } = useContext(AuthContext);
  const token = user?.token || localStorage.getItem("token");
  const companyId = user?.accountType === "COMPANY" ? user?.id : user?.companyId;
  const navigate = useNavigate();
  const location = useLocation();
  const viewportWidth = useViewportWidth();

  const isAuthenticated = !!token;
  const isPublicRoute = PUBLIC_ROUTES.includes(location.pathname);
  const isMobile = viewportWidth < 640;
  const maxBoxes = isMobile
    ? 1
    : Math.max(1, Math.min(3, Math.floor((viewportWidth - BUBBLE_COLUMN_WIDTH - 16) / (BOX_WIDTH + BOX_GAP))));

  const [apiKey, setApiKey] = useState(null);
  const [connected, setConnected] = useState(false);
  const [tabVisible, setTabVisible] = useState(typeof document === "undefined" ? true : !document.hidden);

  // chats: most-recent-first. Each = { number, name, preview, unread, lastTs,
  //   open, minimized, openedAt, messages[], status: idle|loading|ready|error }
  const [chats, setChats] = useState([]);

  const clientRef = useRef(null);
  const notifSubRef = useRef(null);
  const contactSubsRef = useRef({});
  const seenIdsRef = useRef(new Set());
  const hadConnectionRef = useRef(false);

  // Always-fresh copies for use inside long-lived websocket callbacks
  const chatsRef = useRef(chats);
  chatsRef.current = chats;
  const userRef = useRef(user);
  userRef.current = user;
  const companyIdRef = useRef(companyId);
  companyIdRef.current = companyId;

  const updateChat = useCallback((number, patch) => {
    setChats((prev) => prev.map((c) => (c.number === number ? { ...c, ...(typeof patch === "function" ? patch(c) : patch) } : c)));
  }, []);

  /* ---- apiKey (needed for the topic names + sending) ---- */
  useEffect(() => {
    if (!isAuthenticated || !companyId) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/whatsappConfig/${companyId}`, {
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        });
        const result = await res.json();
        if (!cancelled && res.ok && result.status === "success" && result.data?.apiKey) {
          setApiKey(result.data.apiKey);
        }
      } catch (err) {
        console.error("WhastappNotification: failed to load config", err);
      }
    })();
    return () => { cancelled = true; };
  }, [isAuthenticated, companyId, token]);

  /* ---- chat taken by another executive: disable replying ---- */
  const lockChat = useCallback((number, message) => {
    setChats((prev) => prev.map((c) => (
      c.number === number && !c.locked
        ? { ...c, locked: true, unread: 0, lockMessage: message || "This chat was picked up by another executive." }
        : c
    )));
  }, []);

  /* ---- history for a chatbox ---- */
  const loadHistory = useCallback(async (number) => {
    updateChat(number, { status: "loading" });
    try {
      const url = new URL(`${API_URL}/api/whatsapp-chat/chat`);
      url.searchParams.append("sender", number);
      url.searchParams.append("page", 0);
      url.searchParams.append("size", HISTORY_SIZE);
      const res = await fetch(url.toString(), { headers: { Authorization: `Bearer ${token}` } });
      if (isClaimedStatus(res.status)) {
        lockChat(number);
        updateChat(number, { status: "ready" });
        return;
      }
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const body = await res.json();
      const history = (body.data || [])
        .filter((m) => m && !isReaction(m))
        .map((m, i) => formatMessage(m, i))
        .sort((a, b) => toMs(a.timestamp) - toMs(b.timestamp));
      updateChat(number, (c) => ({ status: "ready", messages: mergeMessages(history, c.messages) }));
    } catch (err) {
      console.error("WhastappNotification: history load failed", err);
      updateChat(number, { status: "error" });
    }
  }, [token, updateChat, lockChat]);

  const loadHistoryRef = useRef(loadHistory);
  loadHistoryRef.current = loadHistory;

  /* ---- new-message notification -> create / refresh a bubble ---- */
  const handleNotification = useCallback((rawBody) => {
    let data;
    try {
      data = JSON.parse(rawBody);
    } catch (e) {
      console.error("WhastappNotification: bad payload", e, rawBody);
      return;
    }

    // Only customer messages, not our own outgoing sends
    if (data.direction && data.direction !== "INCOMING") return;
    const number = String(data.from || data.number || data.sender || "");
    if (!number) return;

    // Claimed by another executive: no bubble; lock the box if one is open
    if (!shouldNotify(data, userRef.current)) {
      lockChat(number);
      return;
    }

    // Already reading this contact on the full Chat page
    if (window.__waActiveContact === number) return;

    const id = data.wamid || data.messageId;
    if (id) {
      if (seenIdsRef.current.has(id)) return;
      seenIdsRef.current.add(id);
      if (seenIdsRef.current.size > 500) seenIdsRef.current.delete(seenIdsRef.current.values().next().value);
    }

    const name = String(data.contactName || data.senderName || number);
    const preview = extractMessageText(data);
    const now = Date.now();

    setChats((prev) => {
      const existing = prev.find((c) => c.number === number);
      if (existing) {
        // If its box is open, the per-contact subscription owns messages + unread
        const updated = {
          ...existing,
          name,
          preview,
          lastTs: now,
          unread: existing.open ? existing.unread : existing.unread + 1,
        };
        return [updated, ...prev.filter((c) => c.number !== number)];
      }
      const fresh = {
        number, name, preview, unread: 1, lastTs: now,
        open: false, minimized: false, openedAt: 0,
        messages: [], status: "idle", locked: false, lockMessage: "",
      };
      const next = [fresh, ...prev];
      if (next.length <= MAX_BUBBLES) return next;
      // drop the oldest bubbles that aren't open
      const keep = [];
      let slots = MAX_BUBBLES;
      next.forEach((c) => {
        if (c.open) { keep.push(c); slots -= 1; }
      });
      next.forEach((c) => {
        if (!c.open && slots > 0) { keep.push(c); slots -= 1; }
      });
      return next.filter((c) => keep.includes(c));
    });
  }, [lockChat]);

  /* ---- live message inside an open chatbox ---- */
  const handleContactMessage = useCallback((number, rawBody) => {
    let msg;
    try {
      msg = JSON.parse(rawBody);
    } catch (e) {
      return;
    }
    if (!msg || isReaction(msg)) return;
    if (!shouldNotify(msg, userRef.current)) {
      lockChat(number);
      return;
    }

    const formatted = formatMessage(msg);
    const incoming = formatted.sender === "them";
    const current = chatsRef.current.find((c) => c.number === number);
    if (!current) return;

    setChats((prev) => prev.map((c) => {
      if (c.number !== number) return c;
      const idx = c.messages.findIndex((m) => isSameMessage(m, formatted));
      if (idx >= 0) {
        // re-delivery / status change / echo of our optimistic message: adopt real id + status
        const messages = [...c.messages];
        messages[idx] = { ...messages[idx], ...formatted };
        return { ...c, messages };
      }
      const seen = !c.minimized && !document.hidden;
      return {
        ...c,
        messages: [...c.messages, formatted],
        preview: incoming ? formatted.text : c.preview,
        unread: incoming && !seen ? c.unread + 1 : c.unread,
      };
    }));

    // Being read right now: clear the Sidebar badge (twice, in case the Sidebar's
    // own listener increments it a moment after us)
    if (incoming && !current.minimized && !document.hidden) {
      const cid = companyIdRef.current;
      markGlobalRead(cid, number, formatted.timestamp);
      setTimeout(() => markGlobalRead(cid, number, formatted.timestamp), 600);
    }
  }, [lockChat]);

  /* ---- websocket: one STOMP client for notifications ---- */
  useEffect(() => {
    if (!isAuthenticated || !apiKey) return;

    const client = new Client({
      brokerURL: WS_URL,
      reconnectDelay: 5000,
      heartbeatIncoming: 10000,
      heartbeatOutgoing: 10000,
      onConnect: () => {
        contactSubsRef.current = {}; // old subscriptions died with the old socket
        notifSubRef.current = client.subscribe(`/topic/notifications/${apiKey}`, (frame) => handleNotification(frame.body));
        setConnected(true);
        // After a reconnect, catch up on anything missed in open chatboxes
        if (hadConnectionRef.current) {
          chatsRef.current.filter((c) => c.open).forEach((c) => loadHistoryRef.current(c.number));
        }
        hadConnectionRef.current = true;
      },
      onDisconnect: () => setConnected(false),
      onWebSocketClose: () => setConnected(false),
    });

    clientRef.current = client;
    client.activate();

    return () => {
      try { notifSubRef.current?.unsubscribe(); } catch (_) {}
      Object.values(contactSubsRef.current).forEach((s) => { try { s.unsubscribe(); } catch (_) {} });
      contactSubsRef.current = {};
      client.deactivate();
      clientRef.current = null;
      hadConnectionRef.current = false;
      setConnected(false);
    };
  }, [isAuthenticated, apiKey, handleNotification]);

  /* ---- per-contact subscriptions follow the open chatboxes ---- */
  const openNumbers = chats.filter((c) => c.open).map((c) => c.number).sort().join("|");
  useEffect(() => {
    const client = clientRef.current;
    if (!connected || !client || !apiKey) return;
    const wanted = new Set(openNumbers ? openNumbers.split("|") : []);
    const subs = contactSubsRef.current;

    Object.keys(subs).forEach((n) => {
      if (!wanted.has(n)) {
        try { subs[n].unsubscribe(); } catch (_) {}
        delete subs[n];
      }
    });
    wanted.forEach((n) => {
      if (!subs[n]) {
        subs[n] = client.subscribe(`/topic/chatMessages/${apiKey}/${n}`, (frame) => handleContactMessage(n, frame.body));
      }
    });
  }, [connected, openNumbers, apiKey, handleContactMessage]);

  /* ---- keep the number of open boxes within what fits the screen ---- */
  const openCount = chats.filter((c) => c.open).length;
  useEffect(() => {
    setChats((prev) => {
      const open = prev.filter((c) => c.open).sort((a, b) => b.openedAt - a.openedAt);
      if (open.length <= maxBoxes) return prev;
      const toClose = new Set(open.slice(maxBoxes).map((c) => c.number));
      return prev.map((c) => (toClose.has(c.number) ? { ...c, open: false, minimized: false, status: "idle" } : c));
    });
  }, [maxBoxes, openCount]);

  /* ---- tab visibility: only count messages as "seen" while the tab is visible ---- */
  useEffect(() => {
    const onVis = () => setTabVisible(!document.hidden);
    document.addEventListener("visibilitychange", onVis);
    return () => document.removeEventListener("visibilitychange", onVis);
  }, []);

  /* ---- an expanded, visible chatbox means its unread count is cleared ---- */
  useEffect(() => {
    if (!tabVisible) return;
    const toClear = chats.filter((c) => c.open && !c.minimized && c.unread > 0);
    if (!toClear.length) return;
    toClear.forEach((c) => markGlobalRead(companyId, c.number, Date.now()));
    setChats((prev) => prev.map((c) => (c.open && !c.minimized && c.unread > 0 ? { ...c, unread: 0 } : c)));
  }, [chats, tabVisible, companyId]);

  /* ---- logout / session end: reset everything ---- */
  useEffect(() => {
    if (!isAuthenticated) {
      setChats([]);
      setApiKey(null);
      seenIdsRef.current.clear();
    }
  }, [isAuthenticated]);

  /* ---- dev helper: fake an incoming message from the browser console ----
   *   window.__waTestBubble("919999999999", "Rahul Sharma", "Hi, is the flat available?")
   */
  useEffect(() => {
    const isProd = typeof process !== "undefined" && process.env && process.env.NODE_ENV === "production";
    if (isProd) return;
    window.__waTestBubble = (from = "910000000000", contactName = "Test Customer", message = "Hello!") =>
      handleNotification(JSON.stringify({ direction: "INCOMING", from, contactName, message, wamid: `test-${Date.now()}` }));
    return () => { delete window.__waTestBubble; };
  }, [handleNotification]);

  /* ---- actions ---- */
  const openChat = (number) => {
    updateChat(number, { open: true, minimized: false, unread: 0, openedAt: Date.now() });
    markGlobalRead(companyId, number, Date.now());
    loadHistory(number);
  };

  const dismissHead = (number) => setChats((prev) => prev.filter((c) => c.number !== number));

  const closeChat = (number) => {
    // a chat owned by someone else has nothing left to do here -> remove its bubble too
    if (chatsRef.current.find((c) => c.number === number)?.locked) return dismissHead(number);
    updateChat(number, { open: false, minimized: false, status: "idle" });
  };

  const toggleMinimize = (number) => updateChat(number, (c) => ({ minimized: !c.minimized, unread: c.minimized ? 0 : c.unread }));

  const openFullChat = (number) => {
    dismissHead(number);
    navigate("/chat", { state: { openContactNumber: number } });
  };

  const sendMessage = useCallback(async (number, text, retryId) => {
    const tempId = retryId || `temp-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;

    if (retryId) {
      updateChat(number, (c) => ({ messages: c.messages.map((m) => (m.id === retryId ? { ...m, status: "sending" } : m)) }));
    } else {
      updateChat(number, (c) => ({
        messages: [...c.messages, {
          id: tempId, text, type: "text", sender: "me", status: "sending", timestamp: new Date().toISOString(),
        }],
      }));
    }

    try {
      const formData = new FormData();
      formData.append("apiKey", apiKey);
      formData.append("to", number);
      formData.append("message", text);
      formData.append("type", "text");

      const res = await fetch(`${API_URL}/api/whatsapp-chat/reply`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      const data = await res.json().catch(() => ({}));

      // Someone else replied first and now owns this chat: drop our message, lock the box
      if (isClaimedStatus(res.status)) {
        updateChat(number, (c) => ({ messages: c.messages.filter((m) => m.id !== tempId) }));
        lockChat(number, data.message);
        return;
      }
      if (!res.ok || data.status !== "success") throw new Error(data.message || "Failed to send message");

      const realId = data.wamid || data.messageId;
      updateChat(number, (c) => {
        // the websocket echo may already have replaced the temp message with the real one
        const messages = c.messages.map((m) => (m.id === tempId ? { ...m, id: realId || m.id, status: "sent" } : m));
        const seen = new Set();
        return { messages: messages.filter((m) => (seen.has(m.id) ? false : (seen.add(m.id), true))) };
      });
      markGlobalRead(companyId, number, Date.now()); // replying means it was read
    } catch (err) {
      console.error("WhastappNotification: send failed", err);
      updateChat(number, (c) => ({ messages: c.messages.map((m) => (m.id === tempId ? { ...m, status: "failed" } : m)) }));
    }
  }, [apiKey, token, companyId, updateChat, lockChat]);

  if (!isAuthenticated || isPublicRoute) return null;

  const openBoxes = chats.filter((c) => c.open).sort((a, b) => b.openedAt - a.openedAt); // newest = rightmost
  const hideBubbles = isMobile && openBoxes.some((c) => !c.minimized);

  return (
    <>
      {/* docked chatboxes */}
      <AnimatePresence>
        {openBoxes.map((chat, i) => (
          <ChatBox
            key={chat.number}
            chat={chat}
            isMobile={isMobile}
            right={isMobile ? 0 : BUBBLE_COLUMN_WIDTH + i * (BOX_WIDTH + BOX_GAP)}
            onClose={() => closeChat(chat.number)}
            onToggleMinimize={() => toggleMinimize(chat.number)}
            onOpenFull={() => openFullChat(chat.number)}
            onSend={(text) => sendMessage(chat.number, text)}
            onRetry={(failedMsg) => (failedMsg ? sendMessage(chat.number, failedMsg.text, failedMsg.id) : loadHistory(chat.number))}
          />
        ))}
      </AnimatePresence>

      {/* bubble column (right edge) */}
      {!hideBubbles && chats.length > 0 && (
        <div className="fixed right-4 bottom-4 z-[9990] flex flex-col items-center gap-3">
          <AnimatePresence initial={false}>
            {chats.map((chat) => (
              <ChatHead
                key={chat.number}
                chat={chat}
                onOpen={() => (chat.open && !chat.minimized ? closeChat(chat.number) : openChat(chat.number))}
                onDismiss={() => { closeChat(chat.number); dismissHead(chat.number); }}
              />
            ))}
          </AnimatePresence>
        </div>
      )}
    </>
  );
};

export default WhastappNotification;













